import React from 'react';

var _ = require('lodash');

function DateFilterLabelCase(customerType) {
  switch(customerType) {
    case "LAST_ORDER": {
      return "Ngày đăng ký đơn hàng"
    }
    case "LAST_LOGIN": {
      return "Ngày đăng nhập"
    }
    default: {
      return "Tất cả"
    }
  }
}

class DateFilter extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {filter_type_selected, onFilter} = this.props;
    const options = [
        {label: "Tất cả", value: "ALL"},
        {label: "Ngày đăng ký đơn hàng", value: "LAST_ORDER"},
        {label: "Ngày đăng nhập", value: "LAST_LOGIN"}
    ]
    const filter_type = _.map(options, (i,index) => {
      return <a key={index} onClick={() => onFilter(i.value)} className="dropdown-item">{i.label}</a>
    })
    return(
      <React.Fragment>
        <div style={{ float: 'right', margin: 5}} className="btn-group">
          <button type="button" className="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            {DateFilterLabelCase(filter_type_selected)}
          </button>
          <div className="dropdown-menu" x-placement="bottom-start">
             {filter_type}
          </div>
        </div>
      </React.Fragment>
    )
  }

}


export default DateFilter;